import _ from 'underscore';
import { CWBaseModel } from 'src/core/models/cwBase.model';

/**
 * collabRecapitulatif activites and absences content
 */
export class CWContentRecapActivitesModel extends CWBaseModel {
  code: string;

  constructor(attributes?: { [key: string]: any }, options?: { [key: string]: any }) {
    if (!options && !_.isEmpty(attributes)) {
      options = attributes;
    }
    options = options || {};
    super(attributes, options);
    this.url = (): string => {
      return Configuration.restRoot + "/rest/composant/recapactivite/detail/" + encodeURIComponent(this.code);
    };
  }

  defaults(): { [key: string]: any } {
    return {
      "activites": null,
      "absences": null
    }
  }
}
